import { ref } from 'vue';

/**
 * Thème clair / sombre. Choix explicite mémorisé dans le navigateur ; à défaut,
 * celui du système. La classe `dark` sur <html> est posée dès `index.html`
 * (script en ligne) : attendre Vue ferait flasher la page en blanc.
 */
export type Theme = 'light' | 'dark';

const STORAGE_KEY = 'billpulse.theme';

function initialTheme(): Theme {
  return document.documentElement.classList.contains('dark') ? 'dark' : 'light';
}

export const theme = ref<Theme>(typeof document === 'undefined' ? 'light' : initialTheme());

export function toggleTheme(): void {
  theme.value = theme.value === 'dark' ? 'light' : 'dark';
  document.documentElement.classList.toggle('dark', theme.value === 'dark');
  try {
    window.localStorage.setItem(STORAGE_KEY, theme.value);
  } catch {
    // Stockage bloqué : le choix vaut pour cette visite seulement.
  }
}
